import { render, staticRenderFns } from "./MAN938P04.vue?vue&type=template&id=7a5d2b2c&"
import script from "./MAN938P04.vue?vue&type=script&lang=js&"
export * from "./MAN938P04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports